// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"f610b15d","306":"96f6ab75","488":"ae704530"}[chunkId] + ".chunk.js";
};